/**
 * Three-tile summary strip (Employees / Shift Types / Assignments) shown
 * right under the roster header.
 */
const RosterStatsTiles = ({ employeesCount, shiftsCount, assignmentsCount }) => (
  <div
    className="grid grid-cols-3 gap-px bg-zinc-200 dark:bg-zinc-800 border border-zinc-200 dark:border-zinc-800"
    data-testid="roster-stats-tiles"
  >
    <div className="bg-white dark:bg-zinc-900 p-4">
      <p className="text-xs uppercase tracking-[0.2em] text-zinc-500 dark:text-zinc-400">
        Employees
      </p>
      <p
        className="text-2xl font-bold tabular-nums text-zinc-900 dark:text-zinc-100 mt-1"
        data-testid="roster-stats-employees"
      >
        {employeesCount}
      </p>
    </div>
    <div className="bg-white dark:bg-zinc-900 p-4">
      <p className="text-xs uppercase tracking-[0.2em] text-zinc-500 dark:text-zinc-400">
        Shift Types
      </p>
      <p
        className="text-2xl font-bold tabular-nums text-zinc-900 dark:text-zinc-100 mt-1"
        data-testid="roster-stats-shifts"
      >
        {shiftsCount}
      </p>
    </div>
    <div className="bg-white dark:bg-zinc-900 p-4">
      <p className="text-xs uppercase tracking-[0.2em] text-zinc-500 dark:text-zinc-400">
        Assignments
      </p>
      <p
        className="text-2xl font-bold tabular-nums text-zinc-900 dark:text-zinc-100 mt-1"
        data-testid="roster-stats-assignments"
      >
        {assignmentsCount}
      </p>
    </div>
  </div>
);

export default RosterStatsTiles;
